<template>
    <div>
        <v-card>
            <div slot="header">
                <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
                    <div>
                        <v-text type="title">
                            Идентификация
                        </v-text>
                    </div>

                    <v-text type="text" danger>
                        Внесите идентификационный платеж от 2500 рублей с расчетного счета 
                        организации или индивидуальрого предпринимателя (пункт 3.1.2 в оферте). 
                        Выбранный Тариф будет активирован автоматически.
                    </v-text>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'contract-electronic',
    props: {
        edoTypes: {
            type: Object,
            default() {
                return {};
            }
        },
        isFetched: Boolean,
        isFilled: Boolean,
        contractLink: String,
    },
    data() {
        return {
            choosenEdo: undefined,
            selectedEdo: undefined,
        }
    },
    methods: {
        handleChooseEdo() {
            this.selectedEdo = this.choosenEdo;
            this.$emit('choose', this.selectedEdo);
        },
        handleChangeEdo() {
            this.selectedEdo = undefined;
            this.choosenEdo = undefined;
        }
    },
    computed: {
        selectedEdoLabel() {
            return this.edoTypes[this.selectedEdo] || '';
        },
        isSelectedDiadok() {
            return Number(this.selectedEdo) === 1;
        },
        isSelectedNotDiadok() {
            return this.selectedEdo && Number(this.selectedEdo) > 1;
        }
    }
}
</script>



// WEBPACK FOOTER //
// ContractElectronic.vue?2cf6940e